import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  BUZZONE_SCHOOLS_ROUTE,
  BUZZONE_STAFFS_ROUTE,
  BUZZONE_STUDENTS_ROUTE,
} from '../../routes/routes';
import { useDispatch } from 'react-redux';
import { getAllBuzzOneSchools } from './BuzzOneSlice';
import BuzzOneSchools from './Schools/BuzzOneSchools';
import BuzzOneSideNavBar from './BuzzOneSideNavBar';
import BuzzOneSchoolStaffs from './SchoolStaffs/BuzzOneSchoolStaffs';
import BuzzOneSchoolStudents from './SchoolStudents/BuzzOneSchoolStudents';
// import useToggleSideNav from '../../hooks/useToggleSideNav';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

export default function BuzzOne() {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllBuzzOneSchools());
  }, []);

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">BuzzOne</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Manage All BuzzOne related resources from one place.
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10}>
        <Box minWidth={300} pt={4}>
          <BuzzOneSideNavBar />
        </Box>
        <Box flex={9} pt={4} maxWidth={1060}>
          <Switch>
            <PrivateRoute
              exact
              path={BUZZONE_SCHOOLS_ROUTE}
              component={BuzzOneSchools}
            />
            <PrivateRoute
              exact
              path={BUZZONE_STAFFS_ROUTE}
              component={BuzzOneSchoolStaffs}
            />
            <PrivateRoute
              exact
              path={BUZZONE_STUDENTS_ROUTE}
              component={BuzzOneSchoolStudents}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}
